import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  defineProps,
  defineEmits,
  getCurrentInstance,
  defineExpose,
  nextTick,
} from "../../../adapter-vue";

import 
TUIChatEngine,
{
  TUIGlobal,
  IMessageModel,
  TUIStore,
  StoreName,
  TUITranslateService,
  TUIChatService,
} from "@tencentcloud/chat-uikit-engine";

import Link from "./link";
import MessageText from "./message-elements/message-text.vue";
import MessageImage from "./message-elements/message-image.vue";
import MessageAudio from "./message-elements/message-audio.vue";
import MessageFile from "./message-elements/message-file.vue";
import MessageFace from "./message-elements/message-face.vue";
import MessageCustom from "./message-elements/message-custom.vue";
import MessageTip from "./message-elements/message-tip.vue";
import MessageBubble from "./message-elements/message-bubble.vue";
import MessageLocation from "./message-elements/message-location.vue";
import MessageTimestamp from "./message-elements/message-timestamp.vue";
import MessageVideo from "./message-elements/message-video.vue";
import MessageTool from "./message-tool/index.vue";
import MessageRevoked from "./message-tool/message-revoked.vue";
import Dialog from "../../common/Dialog";

import { getImgLoad } from "../utils/utils";
import { CHAT_SCROLL_TYPE } from "../../../constant";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["handleEditor"],
  setup(__props, { emit: emits }) {

const isH5 = ref(TUIGlobal.getPlatform() === "h5");
const isPC = ref(TUIGlobal.getPlatform() === "pc");
const messageListRef = ref();
const title = ref("TUIChat");
const messageList = ref();
const isCompleted = ref(false);
const currentConversationID = ref("");
const nextReqMessageID = ref();
const toggleID = ref("");
const TYPES = ref(TUIChatEngine.TYPES);

// 消息操作气泡调整
const toggleNowRectInfo = ref();
const dialogTop = ref(30);
const listRectInfo = ref();
const list = ref();

// 方法传值
const msgToolRef = ref();

// 消息重发 Dialog
const reSendDialogShow = ref(false);
const resendMessageData = ref();


// web & h5 版本（非 uniapp 平台）, 滚动到目标位置(目前仅支持滚动到指定位置)
// 建议搭配 nextTick 使用
const scrollToTargetInWeb = (type: string, targetElement?: HTMLElement) => {
  switch (type) {
    case CHAT_SCROLL_TYPE.BOTTOM:
      nextTick(() => {
        messageListRef?.value?.lastElementChild?.scrollIntoView &&
          messageListRef?.value?.lastElementChild?.scrollIntoView(false);
        getImgLoad(messageListRef?.value, "message-img", async () => {
          messageListRef?.value?.lastElementChild?.scrollIntoView(false);
        });
      });
      break;
    case CHAT_SCROLL_TYPE.TARGET:
      break;
  }
};

TUIStore.watch(StoreName.CHAT, {
  messageList: (list: Array<IMessageModel>) => {
    messageList.value = list;
    // 滚动到底部，仅支持纯文本消息，仅支持 web & h5 版本
    nextTick(() => {
      scrollToTargetInWeb(CHAT_SCROLL_TYPE.BOTTOM);
    });
  },
  isCompleted: (flag: boolean) => {
    isCompleted.value = flag;
  },
});

TUIStore.watch(StoreName.CONV, {
  currentConversationID: (id: string) => {
    currentConversationID.value = id;
  },
});

const getHistoryMessageList = () => {
  TUIChatService.getMessageList().then((res: any) => {
    const { nextReqMessageID: ID } = res.data;
    nextReqMessageID.value = ID;
  });
};

const openComplaintLink = (type: any) => {
 // window.open(type.url);
};

// web & h5 上传过程中能够滚动到底部
const handleUploadingImageOrVideo = () => {
  nextTick(() => {
    scrollToTargetInWeb(CHAT_SCROLL_TYPE.BOTTOM);
  });
};

// todo：下载和预览
const handleImagePreview = (message: any) => {};

// 消息操作
const handleToggleMessageItem = (
  e: any,
  message: IMessageModel,
  index: number
) => {
  toggleID.value = message.ID;
};

// h5 long press
let timer: number;
const handleH5LongPress = (
  e: any,
  message: IMessageModel,
  index: number,
  type: string
) => {
  if (!isH5.value) return;
  function longPressHandler() {
    clearTimeout(timer);
    handleToggleMessageItem(e, message, index);
  }
  function touchStartHandler() {
    timer = setTimeout(longPressHandler, 500);
  }
  function touchEndHandler() {
    clearTimeout(timer);
  }
  switch (type) {
    case "touchstart":
      touchStartHandler();
      break;
    case "touchend":
      touchEndHandler();
      break;
  }
};

// 消息撤回后，编辑消息
const handleEdit = (message: IMessageModel) => {
  emits("handleEditor", message, "reedit");
};

// 重发消息
const resendMessage = (message: IMessageModel) => {
  reSendDialogShow.value = true;
  resendMessageData.value = message;
};

const resendMessageConfirm = () => {
  reSendDialogShow.value = !reSendDialogShow.value;
  const messageModel = resendMessageData.value;
  messageModel.resendMessage();
};

return { __sfc: true,isH5, isPC, messageListRef, title, messageList, isCompleted, currentConversationID, nextReqMessageID, toggleID, TYPES, toggleNowRectInfo, dialogTop, listRectInfo, list, msgToolRef, reSendDialogShow, resendMessageData, emits, scrollToTargetInWeb, getHistoryMessageList, openComplaintLink, handleUploadingImageOrVideo, handleImagePreview, handleToggleMessageItem, timer, handleH5LongPress, handleEdit, resendMessage, resendMessageConfirm, TUITranslateService, MessageText, MessageImage, MessageAudio, MessageFile, MessageFace, MessageCustom, MessageTip, MessageBubble, MessageLocation, MessageTimestamp, MessageVideo, MessageTool, MessageRevoked, Dialog }
}

})